import React from 'react'
import styled from 'styled-components'
import { FONTS } from '../../../../constants'

export const SummaryRow = (props) => {
  const { projectByID } = props

  const total_change_requests_license_cost = projectByID ? projectByID.$total_change_requests_license_cost : '-'
  const total_change_requests_license_price = projectByID ? projectByID.$total_change_requests_license_price : '-'
  const total_change_requests_hardware_cost = projectByID ? projectByID.$total_change_requests_hardware_cost : '-'
  const total_change_requests_hardware_price = projectByID ? projectByID.$total_change_requests_hardware_price : '-'
  const total_change_requests_other_service_cost = projectByID ? projectByID.$total_change_requests_other_service_cost : '-'
  const total_change_requests_other_service_price = projectByID ? projectByID.$total_change_requests_other_service_price : '-'
  const total_change_requests_other_service_man_days = projectByID ? projectByID.$total_change_requests_other_service_man_days : '-'
  // const total_change_requests_service_cost = $total_change_requests_service_cost
  const total_change_requests_service_price = projectByID ? projectByID.$total_change_requests_service_price : '-'
  const total_change_requests_service_man_days = projectByID ? projectByID.$total_change_requests_service_man_days : '-'

  return (
    <Root>
      <Col>
        <ServiceTitle>Service</ServiceTitle>
        <ServiceText>{`MD: ${total_change_requests_service_man_days}  Price: ${total_change_requests_service_price}`}</ServiceText>
      </Col>
      <Col>
        <OtherTitle>Other Service</OtherTitle>
        <OtherText>{`Cost: ${total_change_requests_other_service_cost}  Price: ${total_change_requests_other_service_price}  MD: ${total_change_requests_other_service_man_days}`}</OtherText>
      </Col>
      <Col>
        <ServiceTitle>Hardware</ServiceTitle>
        <ServiceText>{`Cost: ${total_change_requests_hardware_cost}  Price: ${total_change_requests_hardware_price}`}</ServiceText>
      </Col>
      <Col>
        <OtherTitle>License</OtherTitle>
        <OtherText>{`Cost: ${total_change_requests_license_cost}  Price: ${total_change_requests_license_price}`}</OtherText>
      </Col>
    </Root>
  )
}

const Root = styled.div`
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    background: #404040;
    padding: 0 24px;
    margin-top: 10px;
`

const Col = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const Title = styled.span`
    font-family: ${FONTS.GOTHAM_BOLD};
    font-size: ${FONTS.NORMAL_SIZE};
    margin-bottom: 4px;
`

const Text = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.NORMAL_SIZE};
`

const ServiceTitle = styled(Title)`
    color: #FFFFFF;
`

const ServiceText = styled(Text)`
    color: #FFFFFF;
`

const OtherTitle = styled(Title)`
    color: #C4C4C4;
`

const OtherText = styled(Text)`
    color: #C4C4C4;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-change-request/summary-row.js